import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app/common.service';
import { TransactionDetail, TransactionInfo } from 'src/app/models/transaction-detail.model';
import { RetailStock } from 'src/app/retail-common.service';
import { ServiceStock } from 'src/app/service-stock.service';
import { AccountsService } from 'src/app/services/accounts/accounts.service';

@Component({
  selector: 'app-transaction-info',
  templateUrl: './transaction-info.component.html',
  styleUrls: ['./transaction-info.component.scss'],
})
export class TransactionInfoComponent implements OnInit {

  data:any;
  transactionDetail$: Observable<TransactionDetail>;
  transactionInfo$: Observable<TransactionInfo>;

  constructor(protected _commonService:CommonService, private _accountsService:AccountsService) { }

  ngOnInit(): void {
    this.data = this._accountsService.selectedTransaction;
    this.transactionInfo$ = this._accountsService.fetchTransactionDetails(this.data.transactionRef);
    this.transactionDetail$ = this._accountsService.getTransactionInfo(this.data.accountNumber,this.data.transactionRef);
  }


}
